import React from 'react';
import FormAttachment from "../../../library/form/components/FormAttachment";
import FormROValue from "../../../library/form/components/FormROValue1";
import FormLabel from "../../../library/form/components/FormLabel";
import FormLink from "../../../library/form/components/FormLink";
import FormWrapper from "../../../library/form/components/FormWrapper";
import FormButton from "../../../library/form/components/FormActionButton2";
import FormInput from '../../../library/form/components/FormInput';
import DocChildActivator from "../../cmn/DocChildActivator";
import InvItemAttrs from './InvItemAttrs'
import FormStatus from '../../../library/form/components/FormStatus';
import FormROValueWithTrans from '../../../library/form/components/FormROValueWithTrans';

const InvItemDetailRow = (props) => {
    const { formObject, rowKey } = props;

    return (
        <div className="phViewAreaItem uiBoxItem phViewContent">
            <div className="phViewImage">
                <FormAttachment formObject={formObject} rowKey={rowKey} imgHeight="50px" action={{ InputType: "i", paramName: "itemImage" }} />
            </div>

            <div className="phViewHeader" >
                <div className="phKeyValueView">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "lineNo" }} className="uiBoxItemLineNo" />
                </div>
                <div className="phKeyValueView">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemType" }} className="uiKey" />

                    <FormLink formObject={formObject} rowKey={rowKey} className="uiLink"
                        action={{
                            paramName: "itemId",
                            actionId: "show", actionName: "itemComp",
                            containerKey: "custom",
                            actionParam:{showModeID: "qv"}
                        }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                    <FormROValueWithTrans formObject={formObject} rowKey={rowKey} 
                        yesClass="uiBlue" 
                        className="uiKey" action={{ paramName: "isPreOrder" }}></FormROValueWithTrans>
                </div>
                <div className="phKeyValueView">
                    <span className="uiKey">
                        <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "refType" }} value="" />
                    </span>
                    <FormLink formObject={formObject} rowKey={rowKey} className="uiLink"
                        action={{
                            paramName: "refId",
                            actionId: "show", actionName: "invcomp",
                            containerKey: "popup"
                        }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </div>
            </div>
            <div className="phViewName">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemName" }} />
            </div>
            <div className="phViewInfo">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemDesc" }} />
                <InvItemAttrs formObject={formObject} rowKey={rowKey} action={{ paramName: "itemAttrs" }} />
            </div>
            <div className="phViewRef">
                <FormWrapper customWrapper="div" wrapperClass="phKeyValueView" formObject={formObject} rowKey={rowKey}  action={{ paramName: "stockProfile" }} >
                    <span className="uiKey ">
                        <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "stockProfile" }} value="Stock Profile" />
                    </span>
                    <FormLink useValF={1} formObject={formObject} rowKey={rowKey} className="uiLink uiSpacerH5"
                        action={{
                            paramName: "stockProfile",
                            actionId: "show", actionName: "proComp",
                            containerKey: "popup"
                        }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </FormWrapper>
                <FormWrapper customWrapper="div" wrapperClass="phKeyValueView" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemChannel" }} >
                    <span className="uiKey">
                        <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "itemChannel" }} value="Channel:" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemChannel" }} className="uiValue" />
                </FormWrapper>
                <FormWrapper customWrapper="div" wrapperClass="phKeyValueView" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemChannel" }} >
                    <span className="uiSpacerH5" action={{ paramName: "docStatus" }} >
                        <FormStatus formObject={formObject}  headerKey={`docStatus_${rowKey}`}/>
                    </span>
                </FormWrapper>
            </div>
            <div className="phViewQty">
                <FormInput formObject={formObject} className="uiInput uiVal40" rowKey={rowKey}
                    action={{ InputType: "input", actionId: "refresh", refreshMode:"dep", paramName: "qty1", actionParam: { formulaSource: "QT1", updateNetAmount: "1", viewCaller:"rowViewer" } }} />
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "uom1" }} />
                {/* <FormWrapper customWrapper="div" wrapperClass="uiInline" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemQty2Container" }} > */}
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput uiVal40" 
                        action={{ InputType: "input", actionId: "refresh", refreshMode:"dep", paramName: "qty2", actionParam: { formulaSource: "QT2", updateNetAmount: "1", viewCaller:"rowViewer" } }} />
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "uom2" }} />
                {/* </FormWrapper> */}
                
                {/* <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemQty" }} className="uiValue" style={{ display: "block" }} /> */}

                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "ccQty" }} className="uiFontSize11 uiBlue" />
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemDelivery" }} className="uiFontSize11 uiGreen" />
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemReturn" }} className="uiFontSize11 uiColorRed" />
            </div>
            <div className="phViewCost">
                <FormWrapper formObject={formObject} rowKey={rowKey} action={{ paramName: "costContainer" }} >
                    <FormWrapper customWrapper="div" wrapperClass="phKeyValueView" formObject={formObject} rowKey={rowKey} action={{ paramName: "unitCost" }} >
                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "unitCost" }} value="Cost" />
                        </span>
                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "unitCost" }} className="uiValue" />
                    </FormWrapper>
                    <FormWrapper customWrapper="div" wrapperClass="phKeyValueView" formObject={formObject} rowKey={rowKey} action={{ paramName: "unitPrice" }} >
                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "unitPrice" }} value="Price" />
                        </span>
                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "unitPrice" }} className="uiValue" />
                    </FormWrapper>
                </FormWrapper>
                <FormWrapper formObject={formObject} rowKey={rowKey} action={{ paramName: "salesContainer" }} >
                    <FormWrapper customWrapper="div" wrapperClass="phKeyValueView" formObject={formObject} rowKey={rowKey} action={{ paramName: "discAmt" }} >
                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "discAmt" }} value="Disc." />
                        </span>
                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "discAmt" }} className="uiValue" />
                    </FormWrapper>
                    <FormWrapper customWrapper="div" wrapperClass="phKeyValueView" formObject={formObject} rowKey={rowKey} action={{ paramName: "sellAmt" }} >
                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "sellAmt" }} value="Sell Amt." />
                        </span>

                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "sellAmt" }} className="uiValue uiHighlightBlue" />
                    </FormWrapper>
                    <FormWrapper customWrapper="div" wrapperClass="phKeyValueView" formObject={formObject} rowKey={rowKey} action={{ paramName: "amountDue" }} >
                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "amountDue" }} value="Amt Due" />
                        </span>

                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "amountDue" }} className="uiValue uiHighlightBlue" />
                    </FormWrapper>
                    <FormWrapper customWrapper="div" wrapperClass="phKeyValueView" formObject={formObject} rowKey={rowKey} action={{ paramName: "taxAmt" }} >
                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "taxAmt" }} value="Tax" />
                        </span>

                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "taxAmt" }} />
                    </FormWrapper>
                    <FormWrapper className="phKeyValueView" formObject={formObject} rowKey={rowKey} action={{ paramName: "commAmt" }} >
                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "commAmt" }} value="Comm" />
                        </span>

                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "commAmt" }} />
                    </FormWrapper>
                </FormWrapper>
            </div>
            <div className="phViewAction uiActionBlock">
                <DocChildActivator formObject={formObject} rowKey={rowKey}
                    action={{ actionId: "show", paramName: "childComp", actionParam: {}, containerKey: "popup" }}
                />
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiColorNeutralAction"
                    className="" 
                    action={{ actionId: "edit", paramName: "editBtn", actionParam: { pathKey: "#pathKey" }, containerKey: "popup" }}
                ></FormButton>
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                    className=""
                    action={{ actionId: "del", paramName: "delBtn", actionParam: {}, containerKey: "row" }}
                ></FormButton>
            </div>
        </div>
    )
}

export default InvItemDetailRow